import React from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";

const Grid = ({
  gridColumns,
  gridRows,
  height,
  strokeDasharray,
  strokeColor,
  strokeWidth,
  width
}) => {
  return (
    <g>
      {d3.range(0, width, width / gridColumns).map((x, i) => (
        <line
          key={i}
          x1={x}
          y1={0}
          x2={x}
          y2={height}
          stroke={strokeColor}
          strokeWidth={1}
          strokeDasharray={strokeDasharray}
        />
      ))}
      {d3.range(0, height, height / gridRows).map((y, i) => (
        <line
          key={i}
          x1={0}
          y1={y}
          x2={width}
          y2={y}
          stroke={strokeColor}
          strokeWidth={1}
          strokeDasharray={strokeDasharray}
        />
      ))}
    </g>
  );
};

Grid.defaultProps = {
  gridColumns: 16,
  gridRows: 12,
  height: 0,
  strokeColor: "#000",
  strokeDasharray: "2,2",
  strokeWidth: 1,
  width: 0
};

Grid.propTypes = {
  gridColumns: PropTypes.number,
  gridRows: PropTypes.number,
  height: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeDasharray: PropTypes.string,
  strokeWidth: PropTypes.number,
  width: PropTypes.number
};

export default Grid;
